module.exports = __webpack_public_path__ + "img/step4.172aeca6.jpg";